module.exports = __webpack_public_path__ + "static/1.2.C.6 Plan parter-815719f18a6a8f5de1fc6422812011c2.jpg";